<template>
    <section class="bg-light-blue-03 px-4 xl:px-content py-20 will-change" :data-scroll-section="inner == 'false'">
        <div class="bg-white py-[4.5vw] px-[5.5vw]">

            <h3 class="text-4xl xl:text-heading mb-8" v-show="blockData.title">{{ blockData.title }}</h3>

            <ul class="tabs__nav mb-10 justify-start overflow-y-auto" v-show="blockData.floors">
                <li class="px-4 xl:px-16 leading-snug flex flex-col"
                    :class="{'active text-navy-blue-01' : activeFloor === floor, 'text-navy-blue-03' : activeFloor !== floor }"
                    v-for="(floor, index) in blockData.floors"
                    :key="index"
                    @click="activeFloor = floor"
                >
                    <div class="cursor-pointer whitespace-nowrap text-base xl:text-xl font-canela font-light">{{ floor.name }}</div>
                </li>
            </ul>

            <div v-if="activeFloor" class="grid gap-6 md:grid-cols-10">
                <div class="md:col-span-4">
                    <div class="flex w-full mb-10">
                        <div class="w-1/2" v-show="activeFloor.areas.length > 0">
                            <span class="block text-xs tracking-little text-navy-blue-03 mb-4">{{ __('TOTAL AREA', 'ccave') }}</span>
                            <span class="block text-lg text-navy-blue-02">{{ getTotalAreaSize(activeFloor.areas) }} {{ __('SQM', 'ccave') }}</span>
                        </div>
                        <div class="w-1/2" v-show="activeFloor.type">
                            <span class="block text-xs tracking-little text-navy-blue-03 mb-4">{{ __('TYPE', 'ccave') }}</span>
                            <span class="block text-lg text-navy-blue-02">{{ activeFloor.type }}</span>
                        </div>
                    </div>

                    <div class="flex items-center justify-between border-b border-light-grey text-sm pb-4 pt-7 w-full" v-show="activeFloor.areas" v-for="(area, index) in activeFloor.areas" :key="index">
                        <div >{{ area.name }}</div>
                        <div class="font-bold">{{ area.size }} {{ __('sqm', 'ccave') }}</div>
                    </div>
                </div>

                <div class="md:col-start-5 md:col-span-6">
                    <img class="mx-auto" v-show="activeFloor.image" :src="activeFloor.image.url" :alt="activeFloor.image.alt">
                </div>
            </div>

        </div>
    </section>
</template>


<script>
    export default {
        name: 'Floorplan',
        data() {
            return {
                activeFloor: false
            }
        },
        mounted() {
            this.activeFloor = this.blockData.floors[0]
        },
        methods: {
            getTotalAreaSize(areas) {
                let sum  = 0
                if ( this.activeFloor.total_area === "" ) {
                    areas.forEach(area => {
                        sum += parseFloat(area.size)
                    });
                } else {
                    sum = parseFloat(this.activeFloor.total_area)
                }
                return sum
            }
        },
    }
</script>
